import {Injectable} from '@angular/core';
import {FormSchema} from '@shared/widgets/models/schema';

@Injectable()
export class FormSchemaStoreService {

  private schema: { [key: string]: FormSchema } = {};

  constructor() {
  }

  set(formSchemas: FormSchema, moduleName: string) {
    this.schema[moduleName] = formSchemas;
  }

  get(byModuleName: string) {
    return this.schema[byModuleName];
  }
}
